<!-- 根据不同的选择展示不同的组件 -->
<template>
  <div class="select-contain">
    <!-- 企业标签 -->
    <el-input
      v-show="myType == '1' || myType == ''"
      type="text"
      readonly
      class="my-select"
      placeholder="请选择"
      suffix-icon="el-icon-arrow-down"
      v-model="selectValue1"
      size="mini"
      @click.native="handleTag"
      show-word-limit
      style="width: 165px; margin-right: 10px"
    >
    </el-input>
    <!-- 客户标签 -->
    <el-select
      v-show="myType == '2'"
      v-model="selectValue2"
      placeholder="请选择"
      size="mini"
      @change="selectBindStatus"
      style="width: 165px; margin-right: 10px"
    >
      <el-option
        v-for="item in cusStatuOptions"
        :key="item.ctmCode"
        :label="item.ctmType"
        :value="item.ctmCode"
      >
      </el-option>
    </el-select>
    <!-- 生日 -->
    <el-cascader
      v-show="myType == '3'"
      v-model="selectValue3"
      @change="birthSelect"
      :options="birthList"
      size="mini"
      style="width: 165px; margin-right: 10px"
      collapse-tags
      :props="{ multiple: true }"
      clearable
    ></el-cascader>
    <!-- 性别 -->
    <el-select
      v-show="myType == '4'"
      v-model="selectValue4"
      placeholder="请选择"
      size="mini"
      @change="selectBindStatus"
      style="width: 165px; margin-right: 10px"
    >
      <el-option
        v-for="item in sexOption"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <!-- 省市区 金典-->
    <!-- <el-select
      v-show="myType == '5' && isChongGou"
      collapse-tags
      multiple
      v-model="selectValue5"
      placeholder="请选择"
      size="mini"
      @change="areaChange1"
      class="tags-select-input"
      style="width: 165px; margin-right: 10px"
    >
      <el-option
        v-for="item in areaOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select> -->
    <!-- 省市区 重构 -->
    <el-cascader
      v-show="myType == '5'"
      v-model="selectValue5"
      @change="areaChange2($event)"
      :options="areaOptions"
      size="mini"
      style="width: 165px; margin-right: 10px"
      collapse-tags
      class="area-select"
      :props="{
        multiple: true,
        label: 'text',
        value: 'id',
      }"
      clearable
    >
    </el-cascader>
    <!-- 黑名单客户 -->
    <el-select
      v-show="myType == '6'"
      v-model="selectValue6"
      placeholder="请选择"
      size="mini"
      @change="selectBindStatus"
      style="width: 165px; margin-right: 10px"
    >
      <el-option
        v-for="item in blackListOption"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <!-- 添加标签弹窗 -->
    <AddTags ref="addTags" @addTagsConfirm="addTagsConfirm"></AddTags>
  </div>
</template>
<script>
import { birthData } from "@/utils/common.js";
import AddTags from "@/views/mass/components/addTags.vue";
import { toArrayTree } from "xe-utils";
export default {
  name: "selectOption",
  components: {
    AddTags,
  },
  props: {
    // 为空字符串时不可选， 1为企微标签，2为客户状态，3为生日，4为性别，5为省市区，6为黑名单客户
    myType: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: -1,
    },
    cusStatuOptions: {
      type: Array,
      default: () => {
        [];
      },
    },
    areaContain: {
      type: Object,
      default: () => {
        {
        }
      },
    },
  },
  data() {
    return {
      currentSelectTags: [],
      attributeArr: [
        "ctmTagId",
        "ctmType",
        "birthday",
        "sex",
        "area",
        "isBlacklist",
      ],
      params: {
        ctmTagId: [],
        ctmType: "",
        birthday: [],
        sex: "",
        area: {},
        isBlacklist: "",
      },
      selectValue1: "", // 选择的值
      selectValue2: "", // 选择的值
      selectValue3: "", // 选择的值
      selectValue4: "", // 选择的值
      selectValue5: "", // 选择的值
      selectValue6: "", // 选择的值
      // 客户状态选项
      cusStatus: [
        {
          label: "重要",
          value: 1,
        },
        {
          label: "一般",
          value: 2,
        },
        {
          label: "潜在",
          value: 3,
        },
        {
          label: "回收",
          value: 4,
        },
        {
          label: "沉睡客户",
          value: 5,
        },
      ],
      // 生日选项
      birthList: [],
      // 性别选项
      sexOption: [
        {
          label: "男",
          value: "M",
        },
        {
          label: "女",
          value: "W",
        },
      ],
      // 黑名单选项
      blackListOption: [
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      areaOptions: [],
      isChongGou: false,
    };
  },
  created() {
    this.birthList = birthData;
    this.$nextTick(() => {
      let $el = document.querySelectorAll(
        ".el-cascader-panel .el-cascader-node[aria-owns]"
      );
      Array.from($el).map((item) => {
        item.removeAttribute("aria-owns");
      });
    });
  },
  watch: {
    myType: {
      handler(newVal, oldVal) {
        this.initParams();
        this.$emit("selectValue", this.index, {});
      },
    },
    areaContain: {
      handler(newVal, oldVal) {
        this.areaOptions = this.filterList(toArrayTree(newVal.area));
        console.log(
          "🚀 ~ file: selectOption.vue:202 ~ handler ~ areaOptions:",
          this.areaOptions
        );
        // newVal.area.forEach((item,index,arr) => {
        //       let obj = {
        //         label: item.text,
        //         value: item.id
        //       }
        //       this.areaOptions.push(obj)
        //     })
        this.$nextTick(() => {
          // this.isChongGou = newVal.isChongGou
          // console.log('this.isChongGou',this.isChongGou)
          // console.log('newVal.area',newVal.area)
          // if(!this.isChongGou && newVal.area) {
          //   console.log(111111)
          //   this.areaOptions = []
          //   newVal.area.forEach((item,index,arr) => {
          //     let obj = {
          //       label: item.title,
          //       value: item.id
          //     }
          //     this.areaOptions.push(obj)
          //   })
          // }else {
          //   this.areaOptions = newVal.area
          //   console.log('this.areaOptions',this.areaOptions)
          // }
          let $el = document.querySelectorAll(
            ".el-cascader-panel .el-cascader-node[aria-owns]"
          );
          Array.from($el).map((item) => item.removeAttribute("aria-owns"));
        });
      },
      deep: true,
      immediate: true,
    },
    birthList: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          let $el = document.querySelectorAll(
            ".el-cascader-panel .el-cascader-node[aria-owns]"
          );
          console.log("$el11111", Array.from($el));
          Array.from($el).map((item) => {
            console.log("item", item);
            item.removeAttribute("aria-owns");
          });
        });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  methods: {
    initParams() {
      this.selectValue1 = "";
      this.selectValue2 = ""; // 选择的值
      this.selectValue3 = ""; // 选择的值
      this.selectValue4 = ""; // 选择的值
      this.selectValue5 = ""; // 选择的值
      this.selectValue6 = ""; // 选择的值
      this.currentSelectTags = [];
    },
    filterList(arr) {
      let childs = arr;
      for (let i = childs.length; i--; i > 0) {
        if (childs[i].children) {
          if (childs[i].children.length) {
            this.filterList(childs[i].children);
          } else {
            delete childs[i].children;
          }
        }
      }
      return childs;
    },
    handleTag() {
      if (this.myType == "") {
        this.$message({
          message: "请先选择类型！",
          type: "info",
          offset: 30,
          duration: 1500,
          customClass: "info-message",
        });
      } else {
        this.$refs.addTags.show(this.currentSelectTags);
      }
    },
    selectBindStatus(val) {
      this.params[this.attributeArr[parseInt(this.myType) - 1]] = val;
      let obj = {
        attributeName: this.attributeArr[parseInt(this.myType) - 1],
        value: val,
      };
      this.$emit("selectValue", this.index, obj);
    },
    // 金典区域选择
    areaChange1(val) {
      console.log("金典区域", val);
      let arr = [];
      val.forEach((item) => {
        let areaObject = {
          cityId: "",
          provinceId: "",
          countyId: item,
        };
        arr.push(areaObject);
      });
      let obj = {};
      if (arr.length > 0) {
        obj = {
          attributeName: "area",
          value: arr,
        };
      }
      this.$emit("selectValue", this.index, obj);
    },
    // 重构区域选择
    areaChange2(val) {
      console.log("区域", val);
      let arr = [];
      arr = val.map((item) => {
        // let areaObject = {
        //   cityId: item[1] ? item[1] : "",
        //   provinceId: item[0] ? item[0] : "",
        //   countyId: item[2] ? item[2] : "",
        // };
        // arr.push(areaObject);
        return [
          {
            cityId: item.length > 1 ? item[1] : "",
            provinceId: item.length > 0 ? item[0] : "",
            countyId: item.length > 2 ? item[2] : "",
          },
        ];
      });
      let obj = {};
      if (arr.length > 0) {
        obj = {
          attributeName: "area",
          value: arr,
        };
      }
      this.$emit("selectValue", this.index, obj);
    },
    birthSelect(val) {
      let arr = [];
      if (val.length != 0) {
        arr = JSON.parse(JSON.stringify(val));
        arr = this.handleBirthValue(arr);
      }
      this.params.birthday = arr;
      console.log("this.params", this.params);
      let obj = {};
      if (arr.length > 0) {
        obj = {
          attributeName: "birthday",
          value: this.params.birthday,
        };
      }
      this.$emit("selectValue", this.index, obj);
    },
    handleBirthValue(myArr) {
      myArr.forEach((item, index, arr) => {
        arr[index] = item.join("-");
      });
      return myArr;
    },
    // 新增标签确认事件 val.tagsList: 存有标签名和标签id,用于发送请求; val.nameList 标签名，用于回显数据
    addTagsConfirm(val) {
      console.log("标签1111", val);
      if (val.nameList.length > 1) {
        this.selectValue1 = "已选" + val.nameList.length + "个条件";
      } else {
        this.selectValue1 = val.nameList[0];
      }
      this.currentSelectTags = val.tagsList;
      this.params.ctmTagId = [];
      val.tagsList.forEach((item) => {
        this.params.ctmTagId.push(item.tagId);
      });
      console.log("this.params", this.params);
      let obj = {};
      if (this.params.ctmTagId.length > 0) {
        obj = {
          attributeName: "ctmTagId",
          value: this.params.ctmTagId,
        };
      }
      this.$emit("selectValue", this.index, obj);
    },
  },
};
</script>
<style lang="scss" scoped>
.select-contain {
  /deep/.el-tag {
    margin: 0 0 0 6px;
  }
  .tags-select-input {
    /deep/.el-select__tags {
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow: hidden;
    }
    /deep/.el-select__tags-text {
      display: inline-block;
      max-width: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /deep/ .el-tag__close.el-icon-close {
      top: -6px;
      right: -4px;
    }
  }
  .area-select {
    /deep/.el-cascader__tags {
      white-space: nowrap;
      flex-wrap: nowrap;
      overflow: hidden;
    }
    /deep/.el-cascader__tags .el-tag > span {
      display: inline-block;
      max-width: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    /deep/ .el-tag__close.el-icon-close {
      top: 0;
      right: -4px;
    }
  }
}

.my-select {
  .el-input__inner {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
